import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonToList',
})
export class JsonToListPipe implements PipeTransform {
  transform(value: any): string[] {
    if (!value || typeof value !== 'object') return [`${value || 'N/A'}`];
    return Object.entries(value).map(([key, val]) => `${key}: ${val}`);
  }
}
